import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { Clock } from "lucide-react";
import { API, imgUrl } from "@/lib/api";
import { SectionTitle, Reveal } from "./Reveal";
import { useLang } from "@/i18n/LangContext";

export const BlogCard = ({ b, i, big }) => {
  const { tr } = useLang();
  return (
  <motion.div initial={{ opacity: 0, y: 60 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: false, amount: 0.01 }} transition={{ duration: 0.7, delay: (i % 3) * 0.12 }} className={big ? "md:col-span-2" : ""}>
    <Link to={`/blog/${b.slug}`} className="group block rounded-3xl overflow-hidden bg-[#131B21] border border-[#00C9B7]/15 hover:border-[#00C9B7]/50 transition-colors h-full" data-testid={`blog-card-${b.slug}`}>
      <div className={`overflow-hidden ${big ? "aspect-[16/7]" : "aspect-[16/10]"}`}>
        <img src={imgUrl(b.cover_image) || "/img/sjds-beach.jpg"} alt={b.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
      </div>
      <div className="p-7">
        <div className="flex items-center gap-3 text-xs uppercase tracking-widest text-[#00C9B7] mb-3">
          <span>{b.category}</span><span className="text-slate-600">·</span><span className="text-slate-400 inline-flex items-center gap-1"><Clock size={12} /> {b.read_time.replace("min read", tr("min read", "min de lectura"))}</span>
        </div>
        <h3 className={`font-display uppercase text-white leading-snug mb-3 ${big ? "text-3xl" : "text-xl"}`}>{b.title}</h3>
        <p className="text-sm text-slate-400 line-clamp-3">{b.excerpt}</p>
      </div>
    </Link>
  </motion.div>
  );
};

export const useBlogs = () => {
  const { lang } = useLang();
  const [blogs, setBlogs] = useState(null);
  useEffect(() => {
    axios.get(`${API}/blogs`, { params: { lang } }).then((r) => setBlogs(r.data)).catch(() => setBlogs([]));
  }, [lang]);
  return blogs;
};

export default function BlogTeaser() {
  const blogs = useBlogs();
  const { tr } = useLang();
  if (!blogs?.length) return null;
  return (
    <section className="py-24 sm:py-32" data-testid="blog-teaser-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <SectionTitle eyebrow={tr("From the blog", "Del blog")} title={tr("Smile guides for Nicaragua", "Guías de sonrisa para Nicaragua")} />
          <Reveal from="right"><Link to="/blog" className="text-xs uppercase tracking-[0.25em] text-[#00C9B7] hover:text-white" data-testid="home-all-blogs-link">{tr("All articles →", "Todos los artículos →")}</Link></Reveal>
        </div>
        <div className="grid md:grid-cols-3 gap-6">{blogs.slice(0, 3).map((b, i) => <BlogCard key={b.id} b={b} i={i} />)}</div>
      </div>
    </section>
  );
}
